import { useEffect, useState, type RefObject } from 'react';

type UseInViewOptions = {
  rootMargin?: string;
  threshold?: number | number[];
  initial?: boolean;
};

export function useInView(
  ref: RefObject<Element | null>,
  { rootMargin, threshold = 0, initial = true }: UseInViewOptions = {}
) {
  const [isInView, setIsInView] = useState(initial);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (typeof IntersectionObserver === 'undefined') {
      setIsInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { rootMargin, threshold }
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, [ref, rootMargin, threshold]);

  return isInView;
}
